<!-- ----------------------------------------------------------------------- -->
 <!-- <copyright file="dialog-box.component.html" company="LGT India"> -->
    <!-- Author: vanaraj   -->
    <!-- Copyright (c) LGT India. All rights reserved. -->
 <!-- </copyright> -->
<!-- ----------------------------------------------------------------------- -->
<main class="main-div">
  <div class="add-user">
    <h2 mat-dialog-title class="user-h2">Add User</h2>
    <img [src]="closeIcon" alt="closeIcon" class="close-button" (click)="closeDialog($event)" />
  </div>

  <mat-dialog-content class="mdc-dialog__content">
    <mat-divider></mat-divider>
    <br />
    <div class="input-div">
      <span class="search-icon">
        <img class="search-icon" alt="search-icon" [src]="searchIcon" />&nbsp;
      </span>
      <input
        type="search"
        placeholder="Search & Add User"
        class="example-div"
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchChange($event)"
        (keydown)="handleKeyDown($event)"
      />
    </div>
    <br />
    <div class="users-list">
      <div
      *ngIf="loading"
      style="
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <mat-spinner [diameter]="30"></mat-spinner>
    </div>
      <div *ngIf="noData" class="no-data-message">No data available.</div>
      <mat-list *ngIf="!selectedUser && !noData">
        <ng-container  *ngFor="let user of users; let i = index;" >
          <mat-list-item >
            <mat-radio-button
            class="mat-mdc-radio-button"
            [disabled]="checkIfDisable(user)"
            (change)="selectUser(user)">
        </mat-radio-button>
            <span class="name-span"> {{ user }}</span>
          </mat-list-item>
          <ng-container *ngIf="i < users.length - 1 && i % 7 !== -1">
            <mat-divider></mat-divider>
          </ng-container>
        </ng-container>
      </mat-list>

      <div class="selected-main" *ngIf="selectedUser">
        <div class="selected-user-div">
          <div class="selected-user">
            {{ selectedUser }}
            <div class="admin-check">
              <mat-checkbox class="mdc-checkbox html" [(ngModel)]="makeAdmin" (change)="updateMakeAdmin($event)">
                Is Admin
              </mat-checkbox>
              <mat-checkbox class="mdc-checkbox html" [(ngModel)]="loginAdmin" (change)="updateLoginAdmin($event)">
                Login Access
              </mat-checkbox>
            </div>
          </div>
          <img
            [src]="closeIcon"
            alt="closeIcon"
            height="10px"
            style="cursor: pointer"
            (click)="cancelSelection()"
          />
        </div>
        <div class="footer">
          <button
          mat-raised-button
            color="primary"
            style="
              width: 394px;
              height: 54px;
              padding: 18px, 0px, 18px, 0px;
              border-radius: 5.76px;
              border: 0.72px;
              color: #00498f;
              background: #ffff;
            "
            (click)="cancelSelection()"
          >
            Cancel
          </button>
          <button
            mat-raised-button
            color="primary"
            style="
              width: 394px;
              height: 54px;
              padding: 18px, 0px, 18px, 0px;
              border-radius: 5.76px;
              background: #00498f;
            "
            (click)="closeDialog($event)"
            (click)="addUser()"
            (click)="sendPostRequest()"
          >
            Add User
          </button>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</main>
